import React from 'react';
import {
  Box,
  Typography,
  Grid,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import styled from '@emotion/styled';

const FormImageLeftStyled = styled(Box)(({}) => ({
  background: 'gray',
  width: 100,
  height: 100,
  borderRadius: 100,
  overflow: 'hidden',
  marginRight: 20,
}));

const FormContactRowStyled = styled(Box)(({}) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '20px',
}));

function FAQReadOnly({ data }: any) {
  return (
    <>
      <FormContactRowStyled>
        <Typography variant='h5'>{data.question}</Typography>
      </FormContactRowStyled>
      <FormContactRowStyled>
        <Typography>{data.answer}</Typography>
      </FormContactRowStyled>
    </>
  );
}

function FAQEdit({ data, setPayload }: any) {
  const onFieldEdit = (e: any) => {
    setPayload({
      ...data,
      [e.target.name]: e.target.value,
    });
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          label='Question'
          name='question'
          defaultValue={data.question}
          onBlur={onFieldEdit}
          fullWidth={true}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label='Answer'
          name='answer'
          defaultValue={data.answer}
          onBlur={onFieldEdit}
          fullWidth={true}
          multiline
          minRows={5}
        />
      </Grid>
    </Grid>
  );
}

export { FAQReadOnly, FAQEdit };
